import React from 'react';
//import axios from 'axios'
import { useFormik } from 'formik';
import './styles/form.css'
import * as Yup from 'yup'
//import { loadProgressBar } from 'x-axios-progress-bar'
import 'x-axios-progress-bar/dist/nprogress.css'

//const port=process.env.REACT_APP_PORT2
const baseUrl= process.env.REACT_APP_HOST


const ObservationsForm=()=>{
    const formik = useFormik({
        initialValues: {
            startDate: new Date().toISOString().substr(0,10),
            endDate: new Date().toISOString().substr(0,10),
        },
        validationSchema: Yup.object({
            startDate: Yup.date().required('Please select a start date.'),
            endDate: Yup.date().required('Please select a end date.'),
        })
    });
    
    return (
        <div>
        <form action={baseUrl+'downloadObservationsCSV'} method="GET">
            <label class="mr-2">Start Date</label>
            <input
                class="mr-3"
                id="startDate"
                name="startDate"
                type="date"
                onChange={formik.handleChange}
                value={formik.values.startDate}
            />
            <label class="ml-3">End Date</label>
            <input
                class="ml-2"
                id="endDate"
                name="endDate"
                type="date"
                onChange={formik.handleChange}
                value={formik.values.endDate}
            />
            <div>
            <button class="btn btn-primary mt-4" type="submit">Download Observations</button>
            </div>
        </form>
        </div>

        // <div>
        //     <form action={baseUrl+'downloadObservationsCSV'} method="GET">
        //         <button class="btn-primary" type="submit">Download Observations</button>
        //     </form>
        // </div>
    )
}
export default ObservationsForm;